module.exports = __webpack_public_path__ + "img/crypto-trx.24e6f0fd.svg";